export enum OfferNowType {
    None = -1,
    Yellow = 0,
    Green = 1,
    Purple = 2
}